<ng-container *ngIf='!accessDenied'>
    <div *ngIf="!loader" class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">MEASURE</h5>
                <div style="flex-grow: 1;"></div>
                <button id="add" (click)="addNewMeasure()" class="btn btn-primary float-right mr-3"> Add Measure
                </button>
            </div>

        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-3 light-bg">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center">
                    <input class="w-50 float-left form-control" name="searchBox" id="searchBox" #searchBox
                           maxlength="100"
                           placeholder="Keywords" type="text" ng-reflect-maxlength="100" ng-reflect-model=""
                           [(ngModel)]="measureReg">
                    <div>
                        <button id="Search" (click)="searchPMeasure()" class="btn btn-primary float-left">Search
                        </button>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left mt-3">
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Code">
                        <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Description">
                        <h6 class="mb-lg-0 medium text-truncate"> Description </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Cube Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Cube Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Record Format Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Record Format Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Data Version">
                        <h6 class="mb-lg-0 medium text-truncate"> Data Version </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" ngbTooltip="Actions">
                        <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let measure of measureList;">

                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="{{measure.measureCode}}">
                    <h6 class="mb-lg-0 text-truncate"> {{measure.measureCode}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{measure.measureDisplayName}}">
                    <h6 class="mb-lg-0 text-truncate"> {{measure.measureDisplayName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{measure.description}}">
                    <h6 class="mb-lg-0 text-truncate"> {{measure.description}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{measure.cubeName}}">
                    <h6 class="mb-lg-0 text-truncate"> {{measure.cubeName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{measure.recordFormatName}}">
                    <h6 class="mb-lg-0 text-truncate"> {{measure.recordFormatName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                     ngbTooltip="{{measure.dataVersion | date:mediumDate}}">
                    <h6 class="mb-lg-0 text-truncate"> {{measure.dataVersion | date:mediumDate}} </h6>
                </div>
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <h6 class="mb-lg-0" ngbtooltip="Click for more options" ng-reflect-ngb-tooltip="Click for more options">
                        <i class="fa fa-ellipsis-h" [id]="measure.id" (click)=entityOps($event)></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="selectedMeasureId==measure.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="editMeasure(measure)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li (click)="removeMeasure(measure)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                        </ul>
                    </div>

                </div> -->
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" [id]="measure.id"
                     (mouseenter)=entityOps($event)
                     (mouseleave)=closeDropDown($event)>
                    <h6 class="mb-lg-0">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" style="top:29px" *ngIf="selectedMeasureId==measure.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="editMeasure(measure)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li (click)="removeMeasure(measure)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <ng-container *ngIf="measureList.length == 0">
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>
            <!-- PAGINATION -->
            <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage}} - {{endingPage}} of {{totalMeasures}}
                    items </h6>
                <div class="float-left ml-2 align-v-center">
                    <label class="m-0 float-left">Show items per page</label>
                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                            (change)="OnPageSizeChanged($event)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div style="flex-grow: 1;"></div>
                <ngb-pagination *ngIf='measureList && measureList.length' [collectionSize]="totalMeasures"
                                [rotate]="true"
                                [maxSize]="5" [pageSize]="pageSize" [ellipses]="false" [boundaryLinks]="true"
                                [(page)]="currentPage"
                                (pageChange)="onPageChange($event)" class="float-right"></ngb-pagination>
            </div>
        </div>
        <!-- ADDING OR UPDATING MEASURE -->
        <measureEditor *ngIf="measurePage" [measureData]="measureData" [isEdit]="isEdit"
                       (triggerSave)="loadAfterSaveOrEdit($event)"
                       (triggerBack)="onBack()"></measureEditor>
    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/measure.component.html